<!--
 * @Author: hongye
 * @Date: 2020-09-15 18:30:32
 * @LastEditTime: 2020-11-24 15:08:39
 * @Description: 
-->
<template>
  <div class="online_doc">
        <div class="online_doc_item">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_jiekoushuoming"></i>
            <span>{{ $lang('接口说明') }}</span>
          </p>
          <p class="explain_info" v-if="!onlineData.apiDescIshtml">{{ $lang(onlineData.apiDesc) }}</p>
          <p class="explain_info" v-else v-html="onlineData.apiDesc"></p>
        </div>
        <div class="online_doc_item explain">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_jiekoudizhi1x"></i>
            <span>{{ $lang('接口信息') }}</span>
          </p>
          <slot name="api_addr_info">
            <p class="api_addr_info api_addr_info_new">{{ $lang('测试地址') }}：{{onlineData.testApi + address}}</p>
            <p class="api_addr_info">{{ $lang('正式地址') }}：{{onlineData.proApi}}</p>
            <p class="api_addr_info">{{ $lang('测试地址') }}apiAccount：<span>679256380346990601</span></p>
            <p class="api_addr_info">{{ $lang('测试') }}privateKey：<span>9e31bd78258642da89fa8880aa2d678f</span></p>
            <p class="api_addr_info">{{ $lang('请求方法') }}：<span>POST</span></p>
            <p class="api_addr_info">{{ $lang('数据类型') }}：<span>X-WWW-FORM-URLENCODED </span></p>
            <p class="api_addr_info">{{ $lang('响应类型') }}：<span>JSON</span></p>
          </slot>
         

        </div>
        <div class="online_doc_item explain">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_canshumiaoshusvg"></i>
            <span>{{ $lang('参数描述') }}</span>
          </p>
          <!-- 参数描述 table表格  -->
          <template v-for="(item,index) in onlineData.postDataList">
                <api-table :title="item.title||''" :dataList="item.value" :key="index" :style="{marginTop:index?'20px':'0'}"></api-table>
          </template>
        </div>
        <div class="online_doc_item explain">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_baowenmiaoshu"></i>
            <span>{{ $lang('报文描述') }}</span>
          </p>
          <!-- 报文描述  table表格  -->
           <template v-for="(item,index) in onlineData.responseDataList">
                <api-table :title="item.title||''" :dataList="item.value" :key="index" :style="{marginTop:index?'20px':'0'}"></api-table>
          </template>
        </div>
        <div class="online_doc_item explain" v-if="onlineData.requestCode">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_qingqiushili"></i>
            <span>{{ $lang('请求示例') }}</span>
          </p>
          <json-viewer
            class="pre_api"
            :expanded="true"
            :expand-depth="5"
            :value='onlineData.requestCode'
            copyable
            :show-double-quotes="true"
          >
            <template v-slot:copy="{ copied }">
              <span class="copy-btn" v-if="copied">{{ $lang('复制成功') }}</span>
              <span class="copy-btn" v-else>{{ $lang('复制') }}</span>
            </template>
          </json-viewer>
        </div>

        <div class="online_doc_item explain" v-if="onlineData.responseCode">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_fanhuishili"></i>
            <span>{{ $lang('返回示例') }}</span>
          </p>

          <json-viewer class="pre_api" copyable :expanded="true" :show-double-quotes="true" :expand-depth="5" :value="onlineData.responseCode">
            <template v-slot:copy="{ copied }">
              <span class="copy-btn" v-if="copied">{{ $lang('复制成功') }}</span>
              <span class="copy-btn" v-else>{{ $lang('复制') }}</span>
            </template>
          </json-viewer>
        </div>

    <div class="online_doc_item explain" v-if="onlineData.successCode">
      <p class="online_doc_item_top">
        <i class="iconfont iconapiwendang_qingqiushili"></i>
        <span>{{ $lang('请求成功案例') }}</span>
      </p>
      <json-viewer
          class="pre_api"
          :expanded="true"
          :expand-depth="5"
          :value='onlineData.successCode'
          copyable
          :show-double-quotes="true"
      >
        <template v-slot:copy="{ copied }">
          <span class="copy-btn" v-if="copied">{{ $lang('复制成功') }}</span>
          <span class="copy-btn" v-else>{{ $lang('复制') }}</span>
        </template>
      </json-viewer>
    </div>

    <div class="online_doc_item explain" v-if="onlineData.failCode">
      <p class="online_doc_item_top">
        <i class="iconfont iconapiwendang_qingqiushili"></i>
        <span>{{ $lang('请求失败案例') }}</span>
      </p>
      <json-viewer
          class="pre_api"
          :expanded="true"
          :expand-depth="5"
          :value='onlineData.failCode'
          copyable
          :show-double-quotes="true"
      >
        <template v-slot:copy="{ copied }">
          <span class="copy-btn" v-if="copied">{{ $lang('复制成功') }}</span>
          <span class="copy-btn" v-else>{{ $lang('复制') }}</span>
        </template>
      </json-viewer>
    </div>

        <div class="online_doc_item explain" v-if="onlineData.isShowCountryCode">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_qingqiushili"></i>
            <span>{{ $lang('国家/地区') }}code</span>
          </p>

          <!-- 错误代码 -->
          <api-country-code-table></api-country-code-table>
        </div>
        <div class="online_doc_item explain">
          <p class="online_doc_item_top">
            <i class="iconfont iconapiwendang_cuowudaima"></i>
            <span>{{ $lang('状态码') }}</span>
          </p>

          <!-- 错误代码 -->
          <api-errcode-table :dataList="onlineData.errcodeJson"></api-errcode-table>
        </div>
      </div>
</template>

<script>
import apiTable from "../components/apiTable";
import apiErrcodeTable from './apiErrcodeTable'
import apiCountryCodeTable from './apiCountryCodeTable'
import { RESPONSE_SUCCESS } from '@/constants'
import { mapGetters, mapActions } from 'vuex'
import JsonViewer from 'vue-json-viewer'
export default {
    components:{apiTable, apiErrcodeTable, apiCountryCodeTable, JsonViewer},
    props:['onlineData'],
    computed: {
      ...mapGetters(['token', 'uuid']),
      address() {
        return ''
      }
    },
    mounted() {
      // 已登录，this.uuid为空再去请求
      if(this.token && this.uuid.length == 0) {
        // 获取用户UUid
        this.getUUid()
      }
    },
    methods: {
      ...mapActions(['SET_UUID']),
      getUUid() {
        this.$API.getCertificationInfo().then((res) => {
          if (res.code === RESPONSE_SUCCESS) {
            // 这里需要判断是否认证通过，认证通过，并且uuid为空，即需要保存
            if(res.data.auditStatus == 2 && this.uuid.length == 0) {
              this.SET_UUID(res.data.uuid)
            }
          }
        })
      },
    }

}
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
.copy-btn {
  font-size: 12px;
  color: #E60000;
}
</style>